import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "lp-page lp-item" }
const _hoisted_2 = {
  class: "lp-breadcrumb",
  "aria-label": "breadcrumb"
}
const _hoisted_3 = { class: "lp-breadcrumb__current" }
const _hoisted_4 = { class: "lp-item__grid" }
const _hoisted_5 = { class: "lp-item__stage" }

import HcIcon from '@/modern/components/ui/HcIcon.vue';
import TrailContextBar from './TrailContextBar.vue';
import SectionPlaylist from './SectionPlaylist.vue';
import ItemPager from './ItemPager.vue';
import { ISection, useLearningPathI18n } from '../view/learningPath';
import type { INavEntry } from './usePathwayItemNav';
import '@/modern/styles/lp.scss';


export default /*#__PURE__*/_defineComponent({
  props: {
    pathway: null,
    pathwayId: null,
    itemTitle: null,
    sections: null,
    current: null,
    prev: null,
    next: null,
    hrefOf: null,
    pathwayHref: null
  },
  setup(__props: any) {



const { tl } = useLearningPathI18n();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "lp-breadcrumb__home"
      }, {
        default: _withCtx(() => [
          _createVNode(HcIcon, {
            name: "home",
            size: 16
          })
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'learning-paths' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(tl)('breadcrumb_root')), 1)
        ]),
        _: 1
      }),
      _createVNode(HcIcon, {
        name: "chevron-right",
        size: 12,
        class: "lp-breadcrumb__sep"
      }),
      _createVNode(_component_router_link, { to: __props.pathwayHref }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.pathway.name), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      (__props.itemTitle)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(HcIcon, {
              name: "chevron-right",
              size: 12,
              class: "lp-breadcrumb__sep"
            }),
            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.itemTitle), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(TrailContextBar, {
      pathway: __props.pathway,
      "pathway-href": __props.pathwayHref,
      "section-number": __props.current ? __props.current.sectionIndex + 1 : null,
      "sections-total": __props.sections.length
    }, null, 8, ["pathway", "pathway-href", "section-number", "sections-total"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(ItemPager, {
          prev: __props.prev,
          next: __props.next,
          "href-of": __props.hrefOf,
          "pathway-href": __props.pathwayHref
        }, null, 8, ["prev", "next", "href-of", "pathway-href"])
      ]),
      (__props.current)
        ? (_openBlock(), _createBlock(SectionPlaylist, {
            key: 0,
            sections: __props.sections,
            "current-section-index": __props.current.sectionIndex,
            "current-resource-id": __props.current.resource.id,
            "pathway-id": __props.pathwayId,
            "pathway-href": __props.pathwayHref
          }, null, 8, ["sections", "current-section-index", "current-resource-id", "pathway-id", "pathway-href"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})